import enviro from 'enviro';
import { useEffect, useState } from 'react';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getFeatureWithRPC } from '../../common/api/featuresApi';
import { isProApiName } from '../SurveyResponses';
import FeatureSurveyModal from './featureSurvey/FeatureSurveyModal';
import { getUserInfo } from '../../common/api/getUserInfo';
import { gate } from 'hub-http/gates';
import Raven from 'raven-js';
import { TrialActivationSuccessModal } from './TrialActivationSuccessModal';
import { jsx as _jsx } from "react/jsx-runtime";
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY',
  FEATURE_SURVEY: 'FEATURE_SURVEY'
};
const TrialActivationSuccessContainer = ({
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  showTrialLoadingState
}) => {
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  const {
    upgradeProduct,
    apiName
  } = upgradeData;
  const apiNameToUse = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const isEligibleForFeatureSurvey = isProApiName(apiNameToUse);
  const shouldShowTrialFeatureSurvey = enviro.isProd() ? isEligibleForFeatureSurvey : isEligibleForFeatureSurvey || window.location.search.includes('showFeatureSurvey');
  const [successModalType, setSuccessModalType] = useState(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
  const [hasStartModalGate, setHasStartModalGate] = useState();
  useEffect(() => {
    if (upgradeData.feature) {
      getFeatureWithRPC({
        shortName: upgradeData.feature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(error => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
        console.error(error);
      });
    }
    setFeatureData({
      feature: undefined,
      fetched: true
    });
  }, [upgradeData]);
  useEffect(() => {
    getUserInfo().then(userInfo => {
      setHasStartModalGate(userInfo.gates.includes(gate('HiC::Trials::StartModal')));
    }).catch(e => Raven.captureException(e));
  }, []);
  useEffect(() => {
    if (undefined !== hasStartModalGate) {
      const initialModal = hasStartModalGate ? SUCCESS_MODAL_TYPES.INITIAL_SUCCESS : shouldShowTrialFeatureSurvey ? SUCCESS_MODAL_TYPES.FEATURE_SURVEY : SUCCESS_MODAL_TYPES.INITIAL_SUCCESS;
      setSuccessModalType(initialModal);
    }
  }, [hasStartModalGate, shouldShowTrialFeatureSurvey]);
  if (undefined === hasStartModalGate) return null;
  const shouldShowFeatureSurvey = successModalType === SUCCESS_MODAL_TYPES.FEATURE_SURVEY;
  if (shouldShowFeatureSurvey) {
    return /*#__PURE__*/_jsx(FeatureSurveyModal, {
      apiName: apiNameToUse,
      setInitialSuccessModal: () => {
        setSuccessModalType(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
      },
      upgradeData: upgradeData
    });
  }
  return hasStartModalGate ? /*#__PURE__*/_jsx(TrialActivationSuccessModal, {
    showTrialLoadingState: showTrialLoadingState && !featureData.fetched,
    onSuccess: onSuccess,
    upgradeData: upgradeData,
    featureData: featureData.feature
  }) : /*#__PURE__*/_jsx(ActivationSuccessModal, {
    type: sourceKeys.TRIAL,
    header: header,
    subText: subText,
    ctaText: ctaText,
    showTrialLoadingState: showTrialLoadingState && !featureData.fetched,
    onSuccess: onSuccess,
    upgradeData: upgradeData,
    featureData: featureData.feature
  });
};
export default TrialActivationSuccessContainer;